













import { Component, Mixins, Prop } from "vue-property-decorator";
import { Size } from "../../../../../base/domain/drawing";
import {
  ModelEditableMixin,
} from "../../../../../base/components/system/mixins";
import {
  ClipboardManager,
  StoreEditor,
  OperatorsContainer,
  ObjectIdPublisher,
  CommonDialogsContainer,
  ScriptGroupEditor,
  ObjectsRemover,
  RangeOfMotionGroupEditor,
} from "./commonComponents";
import { default as FormatPageEditor } from "./FormatPageEditor.vue";
import { FormatStructureEditableMixin } from "../mixins";

@Component({
  components: {
    ClipboardManager,
    StoreEditor,
    OperatorsContainer,
    ObjectIdPublisher,
    CommonDialogsContainer,
    ScriptGroupEditor,
    ObjectsRemover,
    RangeOfMotionGroupEditor,
  }
})
export default class CommonComponentsContainer extends Mixins(FormatStructureEditableMixin, ModelEditableMixin) {
  @Prop()
  toPageEditor: () => FormatPageEditor;

  @Prop({ default: () => new Size(10, 10) })
  gridSize: Size;

  $refs!: {
    clipboardManager: ClipboardManager,
    storeEditor: StoreEditor,
    operators: OperatorsContainer,
    publisher: ObjectIdPublisher,
    dialogs: CommonDialogsContainer,
    scriptGroupEditor: ScriptGroupEditor,
    objectsRemover: ObjectsRemover,
    rangeOfMotionGroupEditor: RangeOfMotionGroupEditor,
  };

  getClipboardManager(): ClipboardManager {
    return this.$refs.clipboardManager;
  }

  getStoreEditor(): StoreEditor {
    return this.$refs.storeEditor;
  }

  getOperators(): OperatorsContainer {
    return this.$refs.operators;
  }

  getPublisher(): ObjectIdPublisher {
    return this.$refs.publisher;
  }

  getDialogs(): CommonDialogsContainer {
    return this.$refs.dialogs;
  }  

  getScriptGroupEditor(): ScriptGroupEditor {
    return this.$refs.scriptGroupEditor;
  }

  getObjectsRemover(): ObjectsRemover {
    return this.$refs.objectsRemover;
  }

  getRangeOfMotionGroupEditor(): RangeOfMotionGroupEditor {
    return this.$refs.rangeOfMotionGroupEditor;
  }
}
